/* ELSŐ import kell maradjon: a landingről átadott tokent a Supabase-kliens és
   az első render ELŐTT veszi le a címsorból (lásd src/handoffCapture.js). */
import './handoffCapture';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AuthCallback from './components/AuthCallback';
import { ConfirmSuccess, ConfirmError } from './components/ConfirmPages';
import AlertEmailStopPage from './components/AlertEmailStopPage';
import reportWebVitals from './reportWebVitals';
import { captureUtm } from './utils/utm';
import { captureReturn } from './utils/returnTo';

captureUtm();
captureReturn();

const path = window.location.pathname;

let PageComponent = App;
if      (path === '/auth/callback')   PageComponent = AuthCallback;
else if (path === '/confirm-success') PageComponent = ConfirmSuccess;
else if (path === '/confirm-error')   PageComponent = ConfirmError;
// E-mailek 1. kör (FE01): a lejárt link oldala a normál belépésre irányít (a régi send-confirmation
// függvény nem létezik; új belépő linket a belépő ablak kér).
else if (path === '/confirm-expired') window.location.replace('/');
else if (path === '/riasztas-level-leallitas') PageComponent = AlertEmailStopPage;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PageComponent />
  </React.StrictMode>
);

reportWebVitals();
